/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  HERC721Storage,
  HERC721StorageInterface,
} from "../../../../contracts/dependant/erc721/HERC721Storage";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseURI_",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
] as const;

const _bytecode =
  "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";

type HERC721StorageConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HERC721StorageConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HERC721Storage__factory extends ContractFactory {
  constructor(...args: HERC721StorageConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    name_: PromiseOrValue<string>,
    symbol_: PromiseOrValue<string>,
    baseURI_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<HERC721Storage> {
    return super.deploy(
      name_,
      symbol_,
      baseURI_,
      overrides || {}
    ) as Promise<HERC721Storage>;
  }
  override getDeployTransaction(
    name_: PromiseOrValue<string>,
    symbol_: PromiseOrValue<string>,
    baseURI_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name_,
      symbol_,
      baseURI_,
      overrides || {}
    );
  }
  override attach(address: string): HERC721Storage {
    return super.attach(address) as HERC721Storage;
  }
  override connect(signer: Signer): HERC721Storage__factory {
    return super.connect(signer) as HERC721Storage__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HERC721StorageInterface {
    return new utils.Interface(_abi) as HERC721StorageInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HERC721Storage {
    return new Contract(address, _abi, signerOrProvider) as HERC721Storage;
  }
}
